import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { MessageCircle } from "lucide-react";
import { WaitingRoomChat } from "./WaitingRoomChat";

interface ProviderChatPopoverProps {
  sessionId: string;
  memberName: string;
}

export function ProviderChatPopover({ sessionId, memberName }: ProviderChatPopoverProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <MessageCircle className="h-4 w-4" />
          Message
        </Button>
      </PopoverTrigger>
      <PopoverContent 
        className="w-80 p-0" 
        align="end"
        side="left"
      >
        <div className="px-3 py-2 border-b bg-muted/50">
          <p className="text-sm font-medium">Chat with {memberName}</p>
          <p className="text-xs text-muted-foreground">Send a message before admitting</p>
        </div>
        <WaitingRoomChat 
          sessionId={sessionId} 
          senderRole="provider" 
          className="h-72"
        />
      </PopoverContent>
    </Popover>
  );
}
